import { useState, useEffect, type ReactNode } from 'react';

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(hover: none) or (max-width: 768px)'); // Define your breakpoint
        const updateIsMobile = () => setIsMobile(mediaQuery.matches);

        updateIsMobile(); // Set initial state
        mediaQuery.addEventListener('change', updateIsMobile); // Listen for changes

        return () => mediaQuery.removeEventListener('change', updateIsMobile); // Cleanup
    }, []);

    return isMobile;
};

interface HideProps {
    readonly children: ReactNode;

    /**
     * Visible only on desktop
     */
    readonly mdUp: boolean;

    /**
     * Visible only on tablet and phone
     */
    readonly smDown: boolean;
}

export const Hide: React.FC<HideProps> = ({ children, mdUp = false, smDown = false }) => {
    const isMobile = useIsMobile();

    if (
        (smDown && isMobile)
        || (mdUp && !isMobile)
    ) {
        return children;
    }

    return null;
};
